
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/recepcion/ParteInterface';

import { AgregarPartesAmparoParams, AsignarExpedienteAmparoParams, BuscarAmparoParams, BuscarAmparoResponse, defaultGenerarCaratulaAmparo, EditarAmparoParams, GenerarCaratulaAmparoResponse } from '../../interfaces/recepcion/AmparoInterface';

export const BuscarAmparo = ( params: BuscarAmparoParams ) => {

    return new Promise<BuscarAmparoResponse[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Amparo/BuscarAmparo', params, token)
            .then( ({ data } : { data : BuscarAmparoResponse[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const EditarAmparo = ( params: EditarAmparoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Amparo/EditarAmparo', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPartesAmparo = ( id: number ) => {

    return new Promise<ParteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Amparo/ObtenerPartesAmparo/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarPartesAmparo = ( params: AgregarPartesAmparoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Amparo/AgregarPartesAmparo', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const AsignarExpedienteAmparo = ( params: AsignarExpedienteAmparoParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Amparo/AsignarExpedienteAmparo', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const GenerarCaratulaAmparo = ( idAmparo: number ) => {

    return new Promise<GenerarCaratulaAmparoResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Amparo/GenerarCaratula/${ idAmparo }`, token)
            .then( ({ data } : { data : GenerarCaratulaAmparoResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarCaratulaAmparo, message: error.message } );
            });

        }

    });

}

export const EliminarCaratulaAmparo = ( idAmparo: number ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Amparo/EliminarCaratula/${ idAmparo }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
